import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  ChartBar, UsersThree, ShieldStar, FileText, Coins, Sparkle, WarningCircle,
  SignOut, User as UserIcon, Gear, IdentificationCard,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/dashboard", icon: ChartBar, label: "Visão Geral" },
  { to: "/leads", icon: Sparkle, label: "Leads" },
  { to: "/clients", icon: UsersThree, label: "Clientes" },
  { to: "/garantia", icon: ShieldStar, label: "Garantia Locatícia" },
  { to: "/contracts", icon: FileText, label: "Contratações Ativas" },
  { to: "/inadimplencia", icon: WarningCircle, label: "Inadimplência" },
  { to: "/analysis", icon: IdentificationCard, label: "Análise por CPF" },
  { to: "/financial", icon: Coins, label: "Financeiro" },
  { to: "/settings", icon: Gear, label: "Configuração do Site" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 shrink-0 bg-white border-r border-[var(--line)] flex flex-col" data-testid="app-sidebar">
        <div className="p-5 border-b border-[var(--line)]">
          <img src="https://customer-assets-m6fa6gv7.emergentagent.net/job_locacao-shield/artifacts/5k0zetdw_logo%20safimob%2003.JPG" alt="Safimob" className="h-10 mb-1" />
          <div className="text-[10px] text-slate-500 mt-2 tracking-widest uppercase pl-1">Painel interno</div>
        </div>
        <nav className="p-3 flex-1">
          {NAV.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end
              data-testid={`nav-${it.to.replace("/", "")}`}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              <it.icon size={18} weight="duotone" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[var(--line)]">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-9 h-9 rounded-full bg-[var(--emerald-soft)] flex items-center justify-center">
              <UserIcon size={16} color="#1E2A44" />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{user?.name}</div>
              <div className="text-[11px] text-slate-500 truncate">{user?.email}</div>
            </div>
          </div>
          <button data-testid="logout-btn" onClick={logout} className="nav-link w-full mt-1">
            <SignOut size={18} /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 overflow-x-hidden">{children}</main>
    </div>
  );
}
